<template>
  <section>
    <VInputNumberRusV2
      label="Недостача"
      v-model="localPosition.shipmentStatus.complainedByReceipt"
      :type="Qty"
      disabled
      :unit="localPosition.unit"
    >
      <template #helper-text>
        Это ситуация, когда на Техноскладе приняли меньше, чем отгружено
      </template>
    </VInputNumberRusV2>


    <VInputNumberRusV2
      label="Брак"
      v-model="localPosition.shipmentStatus.complainedSubstandard"
      :type="Qty"
      :validate-method="validateComplainedSubstandard"
      :unit="localPosition.unit"
    >
      <template #helper-text>
        Это товар, который не соответствуют установленным
        стандартам качества и не может быть использован.
      </template>
    </VInputNumberRusV2>
  </section>
</template>

<script lang="ts">
import { UnwrapNestedRefs } from 'vue';
import Qty from '@/core/types/Qty';
import OrderPosition from '@/domains/Orders/OrderPosition';

// Два контрола через которые заполняется претензия,
// удобно иметь блок контролов, чтобы не писать постоянно одно и то же
export default {
  name: 'OrderPositionComplaintInputs',

  props: {
    localPosition: {
      type: Object as PropType<OrderPosition | UnwrapNestedRefs<OrderPosition>>,
      required: true
    }
  },

  setup() {
    return { Qty };
  },

  methods: {
    validateComplainedSubstandard(value: Qty): string | null {
      if (value.isEmpty() === false && value.greaterThan(this.localPosition.shipmentStatus.total)) {
        return 'Количество брака не может быть больше общего количества';
      }
      else {
        return null;
      }
    }
  }
};
</script>
